import React from "react";
import { DateCell } from "@/components/date/cell";
import { CustomList } from "components/index";
import { RenderProfile } from "components/render-profile";

import { useParams } from "react-router-dom";

export default function PendingReviews() {
  const { quadId } = useParams();

  const columns = [
    {
      id: "employee",
      header: "Reviewer",
      accessorKey: "employee",
      cell: ({ row, getValue }) => {
        const user = {
          id: row.original.id,
          first_name: row.original.first_name,
          last_name: row.original.last_name,
          avatar: row.original.avatar,
        };
        return <RenderProfile user={user} />;
      },
    },
    {
      id: "pending_count",
      header: "Pending Reviews",
      accessorKey: "pending_count",
    },
    {
      id: "last_reviewed_date",
      header: "Last Reviewed",
      accessorKey: "last_reviewed_date",
      cell: DateCell,
    },
  ];

  const effectiveFilters = {
    quadrimesterId: quadId,
  };

  const exportFields = [
    "name",
    "pending_count",
    "last_reviewed_date",
  ];

  return (
    <div className="flex-1 h-full">
      <CustomList
        title={"Pending Reviews"}
        endPoint="performance-review/reviewer-pending-summary"
        export={true}
        fields={exportFields}
        filters={effectiveFilters}
        columns={columns}
        storageKey={`pending-reviews-by-reviewee-${quadId}`}
        showSearch={false}
        teleportFilters={true}
      />
    </div>
  );
}
